import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
import { useIconPalette } from "../Icons/IconProvider";
/**
 * @private
 * @returns
 */
export function useConfigurationStatus(cfgObject) {
    var _a;
    const t = useUiTranslator();
    const Icons = useIconPalette();
    const cfgObjectName = (_a = cfgObject.name) !== null && _a !== void 0 ? _a : cfgObject.id;
    const textCompleteShort = t("ConfigurationRenderer:ConfigurationStatus.complete.name", "Complete", { cfgObjectName });
    const textIncompleteShort = t("ConfigurationRenderer:ConfigurationStatus.notComplete.name", "Incomplete", { cfgObjectName });
    const textCompleteLong = t("ConfigurationRenderer:ConfigurationStatus.complete.description", "Configuration {{cfgObjectName}} is complete", { cfgObjectName });
    const textIncompleteLong = t("ConfigurationRenderer:ConfigurationStatus.notComplete.description", "Configuration {{cfgObjectName}} is not complete", { cfgObjectName });
    const isComplete = cfgObject.isComplete;
    const statusTextShort = isComplete ? textCompleteShort : textIncompleteShort;
    const statusTextLong = isComplete ? textCompleteLong : textIncompleteLong;
    const StatusIcon = isComplete
        ? Icons.ConfigurationCompleteIcon
        : Icons.ConfigurationIncompleteIcon;
    return {
        isComplete,
        statusTextShort,
        statusTextLong,
        StatusIcon,
    };
}
//# sourceMappingURL=useConfigurationStatus.js.map